export default __webpack_public_path__ + "static/media/start-workflow.9d23268e.svg";